<template>
    <div class="table">
        <!-- 列表数据 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.title" placeholder="报告名称"></el-input>
                    </div>
                </div> 

                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.termRang" placeholder="学期范围"></el-input>
                    </div>
                </div> 

                <div style="display: inline-block; height:40px;"> 
                    <div style="width:160px;">
                        <el-input v-model="form.gradeName" placeholder="年级名称"></el-input>
                    </div>
                </div>

                <div style="display: inline-block; height:40px;"> 
                    <div style="width:160px;">
                        <el-input v-model="form.className" placeholder="班级名称"></el-input>
                    </div>
                </div>

                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                </div>
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary" @click="download()">下载模板</el-button>
                    <el-button type="primary"  @click="setAdd()">生成报告</el-button>
                </div>
            </div>

            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                element-loading-background = "rgba(255, 255,255,0.7)"
                :element-loading-text = "loadingText"
                v-loading="loading"
                border
                default-expand-all>
                <!-- <el-table-column type="selection" width="55" ></el-table-column> -->
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="title" label="报告名称"  :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="termRang" label="学期范围"  :show-overflow-tooltip="true" width="130"></el-table-column>
                <el-table-column prop="gradeName" label="年级名称" width="80"></el-table-column>
                <el-table-column prop="className" label="班级名称" width="80"></el-table-column>
                <el-table-column prop="startDate" label="开始日期" width="90"></el-table-column>
                <el-table-column prop="endDate" label="结束日期" width="90"></el-table-column>
                <el-table-column prop="createName" label="创建者" width="80"></el-table-column>
                <el-table-column prop="gmtCreate" label="发布时间" width="140"></el-table-column>
                <el-table-column prop="" label="发布状态" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.sendStatus == 1">
                            <span style="color:red;">待发布</span>
                        </div>
                        <div v-else-if="scope.row.sendStatus == 2">
                            已发布
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="134px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button style="color:#387EE8;"
                            @click.native.prevent="showData(scope.row)"
                            type="text"
                            size="small">
                            查看报告
                        </el-button>
                        <el-button style="color:#387EE8;" v-if="scope.row.sendStatus == 1"
                            @click.native.prevent="releaseReport(scope.row)"
                            type="text"
                            size="small">
                            立即发布
                        </el-button>
                        <el-button style="color:#387EE8;" v-if="scope.row.sendStatus == 1"
                            @click.native.prevent="reservationReleaseReport(scope.row)"
                            type="text"
                            size="small">
                            预约发布
                        </el-button>
                        <el-dropdown size="mini" @command="(command) => handleCommand(command, scope.row)">
                            <el-button size="mini" type="text" icon="el-icon-d-arrow-right">更多</el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-if="scope.row.sendStatus == 2" command="handleReminderJZ"
                                    icon="el-icon-circle-check">提醒家长</el-dropdown-item>
                                <el-dropdown-item command="handleDownLoadCJ"
                                    icon="el-icon-download">下载学科成绩</el-dropdown-item>
                                <el-dropdown-item command="handleDownloadSY"
                                    icon="el-icon-download">下载素养报告</el-dropdown-item>
                                <el-dropdown-item command="handleDel"
                                    icon="el-icon-circle-check">删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <div style="font-size: 12px; color:red" v-if="scope.row.sendStatus == 1 && scope.row.reservationReleaseDatetime!=null 
                                                                            && scope.row.reservationReleaseDatetime!='' ">
                            预约发布日期时间：{{ scope.row.reservationReleaseDatetime }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <createReport ref="createReport"></createReport>
        </div>
        <!--查看报告 -->
        <div v-if="reportDetailsVisible">
            <reportDetails ref="reportDetails"></reportDetails>
        </div>
        <!--通知家长 -->
        <div v-if="reportNoticeVisible">
            <reportNotice ref="reportNotice"></reportNotice>
        </div>
        <!--下载模板 -->
        <div v-if="downLoadTempleatVisible">
            <downLoadTempleat ref="downLoadTempleat"></downLoadTempleat>
        </div>
        <!--预约发布 -->
        <div v-if="reservationReleaseVisible">
            <reservationRelease ref="reservationRelease"></reservationRelease>
        </div>
    </div>
</template>

<script>
    import http from '../../../common/http';
    import createReport from './CreateQualityReport.vue';
    import reportDetails from './ReportQualityDetails.vue';
    import reportNotice from './ReportNotice.vue';
    import downLoadTempleat from './DownLoadTempleat.vue';
    import reservationRelease from './ReservationReleaseDialog.vue';
    import axios from 'axios';

    export default {
        name:"",
        data(){
            return{
                addVisible:false,
                reportDetailsVisible:false,
                reportNoticeVisible:false,
                downLoadTempleatVisible:false,
                reservationReleaseVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    deptId:"",
                    title:"",
                    termRang:"",
                    gradeName:"",
                    className:""
                },
                depts:[],
                data:[],
                loading:false,
                loadingText:"",
                currUserId:"",
                socketIoIp:"", // socketIo IP地址
                sourceType:"", //  1-企业内部应用，2-第三方企业应用
                timer: undefined,
            }
        },
        components: {
            createReport, reportDetails, reportNotice, downLoadTempleat, reservationRelease
        },
        created:function () {
            this.getDeptData();
            //获取当前登录用户，然后当前用户不能编辑自己也不能删除自己
            this.currUserId=JSON.parse(sessionStorage.getItem('userinfo')).id;
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.depts=res.data.list;
                       if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                        // 定时刷新累计使用的存储空间
                        this.timer = setInterval(() => {
                            this.getData()
                        }, 5000);
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                // this.loading=true
                // this.loadingText="数据加载中..."

                let url  = this.studentComprehensiveReportListUrl
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.form.deptId,
                    title:this.form.title,
                    termRang:this.form.termRang,
                    gradeName:this.form.gradeName,
                    className:this.form.className
                };       
                // console.log(JSON.stringify(data))
                // return;
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list
                       this.common.total=res.data.total
                       this.socketIoIp = res.data.socketIoIp   
                       this.sourceType = res.data.sourceType
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    // this.loading=false
                },(err)=>{
                    // this.loading=false
                })
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            // 新增界面
            setAdd(){
                this.addVisible=true;
                this.$nextTick(() => {
                    this.$refs['createReport'].init(this.form.deptId, this.socketIoIp, this.sourceType);
                })
            },
            // 删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.studentComprehensiveReportRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.loading=true;
                this.loadingText="删除中...";
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                })
            },
            // 更多操作触发
            handleCommand(command, row) {
                switch (command) {
                    case "handleReminderJZ":
                        this.notice(row)
                        break;
                    case "handleDownLoadCJ":
                        this.downloadFile('score',row.id)
                        break;
                    case "handleDownloadSY":
                        this.downloadFile('report',row.id)
                        break;
                    case "handleDel":
                        this.del(row);
                        break;
                    default:
                        break;
                }
            },
            // 发布报告
            releaseReport(row){
                this.form.id=row.id;
                let msgTipe="发送报告后，学生家长会在钉钉端看到自己孩子的报告数据，是否继续？<br><div style='margin-top:10px;color:red;'>注：请老师在发布报告后，过半个小时再通知家长，也建议家长等待半个小时再查看，因为云端服务器需要1-30分钟的数据同步，才可以把报告给到家长端。</div>";
                // let msgTipe="发送报告后，学生家长会在钉钉端看到自己孩子的报告数据，是否继续？";
                this.$commonFn.showConfirm2(msgTipe,this.releaseReportSuccess);
            },
            releaseReportSuccess(){
                let url  = this.studentComprehensiveReportReleaseReportUrl;
                let data = {
                    id:this.form.id
                };
                this.loading=true;
                this.loadingText="发送中...";
                // console.log(JSON.stringify(data));
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            // 预约发布
            reservationReleaseReport(row){
                this.reservationReleaseVisible = true
                this.$nextTick(() => {
                    this.$refs['reservationRelease'].init(row)
                })
            },
            // 触发详情界面
            showData(row){
                this.reportDetailsVisible = true;
                this.$nextTick(() => {
                    this.$refs['reportDetails'].init(row);
                })
            },
            // 通知家长界面
            notice(row){
                let url  = this.studencomprehensiveReporsendNameListUrl;
                let data = {
                    studentComprehensiveReportId:row.id
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){ 
                        let val = false;
                        for(let i=0;i<res.data.length;i++){
                            if(res.data[i].status == 1){
                                val = true;
                                break;
                           }
                        }
                        if(val){
                            this.$commonFn.showTip('数据还在同步中，同步时间需30分钟，待同步完成后才可以提醒家长。',3);
                            return;
                        }
                        this.reportNoticeVisible = true;
                        this.$nextTick(() => {
                            this.$refs['reportNotice'].init(row);
                        })
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                });
            },
            // 下载模板
            download(){
                this.downLoadTempleatVisible = true;
                this.$nextTick(() => {
                    this.$refs['downLoadTempleat'].openDialog(this.form.deptId, this.socketIoIp, this.sourceType);
                })
            },
            // 下载文件
            downloadFile(fileType,id){
                this.loading=true;
                this.loadingText="正在下载中，下载过程时间可能会比较长，请耐心等待"; 

                let url  = this.studentComprehensiveReportDownloadFileUrl;
                let param = new URLSearchParams();
                param.append('fileType', fileType); 
                param.append('reportId', id); 
                
                axios({
                    method: "post",
                    url: url,
                    data: param, 
                    responseType: "blob"
                }).then(res => {
                    let data= res.data
                    var blob = new Blob([data])
                    // 创建下载的链接
                    var a = document.createElement('a');
                    a.style.display = 'none';
                    var href = window.URL.createObjectURL(blob);
                    a.href = href;
                    //显示下载文件名 获取后端返回的文件名
                    let filename= res.headers['content-disposition'].split('=')[1]
                    // 文件名中有中文 则对文件名进行转码 decodeURI
                    a.download= decodeURI(filename)   
                    // 利用a标签做下载       
                    document.body.appendChild(a);
                    // 点击下载
                    a.click();
                    // 下载后移除元素
                    document.body.removeChild(a);
                    // 释放掉blob对象
                    window.URL.revokeObjectURL(href);
                    this.loading=false;
                }).catch(error => {
                    console.info('response.error'+error.message);
                    this.loading=false;
                });
            }
        },
        destroyed() {
            if(this.timer!=undefined){
                clearInterval(this.timer);
            }
            console.log("实践作业destroy函数执行");
        },
        mixins: [http]
    }

</script>

<style scoped>
     
</style>


// WEBPACK FOOTER //
// src/components/page/complexReport/ComplexQualityReport.vue